<template>
	<div class="hiq-digital-resources__items">
    <ul class="hiq-digital-resources__items-list">
      <li
        class="hiq-digital-resources__items-item"
        data-link-box
        v-for="item in items"
        :key="item.url">
          <div class="hiq-digital-resources__items-item-content">
            <a
              class="hiq-digital-resources__items-item-link"
              :href="item.url">
              <div
                class="hiq-digital-resources__items-item-title"
                v-if="item.title" v-html="item.title">
              </div>
            </a>
            <div
              class="hiq-digital-resources__items-item-desc"
              v-if="item.preamble" v-html="item.preamble">
            </div>
          </div>
        </li>
    </ul>
    <pulse-loader
      v-if="loading"
      :loading="loading"
      :color="'#006349'"
      aria-label="Laddar">
    </pulse-loader>
    <p
      class="hiq-digital-resources__items-text"
      v-if="total > 0">
        Visar {{ items.length }} av {{ total }}
    </p>
    <button
      class="hiq-digital-resources__items-load-more"
      v-if="total > items.length && !loading"
      @click="loadMore">
			  <span class="hiq-digital-resources__items-load-more--text">Visa fler</span>
    </button>

	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { IState, IItem } from '../store/state';
import { search } from '../store/actions';  
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

interface IItemsProps {
  items: [],
}

interface IItemsComputed {
  items: IItem[];
  loading: boolean;
  total: number;
  numberToShow: number;
  initialNumberToShow: number;
}

interface IItemsMethods {
  loadMore(): void;
  focusFirstNewElement(index: number): void;
  updateItemLink(items:NodeListOf<HTMLElement>): void;
}

export default Vue.extend<{}, IItemsMethods ,IItemsComputed ,IItemsProps >({
	name: 'ItemsBlock',
  props: {
    items: [],
  },
	computed: {
    items() {
      return this.$store.getters.items;
    },

    total() {
      return this.$store.getters.total;
    },

    loading() {
      return (this.$store.state as IState).loading;
    },

    numberToShow() {
      return this.$store.getters.numberToShow;
    },

    initialNumberToShow() {
      return (this.$store.state as IState).initialNumberToShow;
    }
	},

  methods: {
    loadMore() {
      let index = this.items.length;
      this.$store.commit({
        type: 'setNumberToShow',
        payload: Number(this.numberToShow) + Number(this.$store.state.initialNumberToShow)
      })
      this.$store.dispatch(search(''));
      this.focusFirstNewElement(index);
    },

    focusFirstNewElement(index: number){
      let links: NodeListOf<HTMLElement> = document
        .querySelectorAll('.hiq-digital-resources__items-item-link');
      let items: NodeListOf<HTMLElement> = document
        .querySelectorAll('.hiq-digital-resources__items-item');

      if(links[index]){
        links[index].focus();
      } else {
        setTimeout(() =>{
          this.focusFirstNewElement(index)
        }, 100);
      }
      if(items) {
        this.updateItemLink(items);
      }
    },

    updateItemLink(items: NodeListOf<HTMLElement>) {
      items.forEach((item: any) => {
        const link:HTMLElement = item.querySelector('a');
        if (link) {
          item.style.cursor = 'pointer';
          const url = link.getAttribute('href') || '/';
          item.addEventListener('click', function () {
            window.location.href = url;
          });
        }
      })
    }
  },
  updated() {
    let items: NodeListOf<HTMLElement> = document
      .querySelectorAll('.hiq-digital-resources__items-item');
    if(items) {
      this.updateItemLink(items);
    }
  },

  components: {
		PulseLoader
  }
})
</script>